import {
	ADVANCED_MANAGEMENT_SET_STEP,
	ADVANCED_MANAGEMENT_STORE_DATA,
	ADVANCED_MANAGEMENT_STORE_DATA_DOCUMENTS,
	ADVANCED_MANAGEMENT_SEARCH_BY_CPF_STARTED,
	ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED,
	ADVANCED_MANAGEMENT_IF_RENDER_MODAL_INVALID_CPF,
	ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_STARTED,
	ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_FINISHED,
	ADVANCED_MANAGEMENT_IS_MANAGER_STARTED,
	ADVANCED_MANAGEMENT_IS_MANAGER_FINISHED,
	ADVANCED_MANAGEMENT_STATUS_FILTERED,
	ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_STARTED,
	ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_FINISHED,
	ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_STARTED,
	ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_FINISHED,
	ADVANCED_MANAGEMENT_CLEAN_ERROR_CANCEL_RELATIONSHIP,
	ADVANCED_MANAGEMENT_SEND_DOCUMENTS_STARTED,
	ADVANCED_MANAGEMENT_SEND_DOCUMENTS_FINISHED,
	ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_CLEAN,
	ADVANCED_MANAGEMENT_SENDING_FILE
} from "../shared/constants";
import {
	searchByCPF,
	getManagerRelationships,
	inviteParticipant,
	cancelRelationship,
	approveRelationship
} from "../shared/multi-accounts-requests-api";
import { isManager } from "../shared/requests-api";
import R from "ramda";

export const getRelationships = () => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_STARTED
		});

		getManagerRelationships().then(response => {
			// Ordenação do mais recente pro mais antigo
			let sorted = R.sortWith([R.descend(R.path(["dateUpdated"]))]);
			let data = response.data.relations.map(relationship => {
				relationship.dateUpdated = new Date(relationship.updated);
				return relationship;
			});
			let badgeCountPendent = 0;
			data = sorted(data);

			if (data && data.length) {
				for (let i = 0; i < data.length; i++) {
					let relationship = data[i];

					if (relationship.status.subStatus === "waitingApprovalManager") {
						badgeCountPendent++;
					}
				}
			}

			dispatch({
				type: ADVANCED_MANAGEMENT_SEARCH_BY_RELATIONSHIP_FINISHED,
				payload: {
					dataRelationship: data,
					dataCurrentStep: response.data.relations.length === 0 ? 5 : 1,
					// isFailureLimitReached: response.data.contFailure >= 2,
					// isInvitationLimitReached: response.data.countSuccess >= 5,
					hasDocuments: response.data.hasDocuments,
					badgeCountPendent
				}
			});
		});
	};
};

export const checkManager = () => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_IS_MANAGER_STARTED
		});

		isManager().then(response => {
			dispatch({
				type: ADVANCED_MANAGEMENT_IS_MANAGER_FINISHED,
				payload: {
					userManager: response.data.isManager
				}
			});
		});
	};
};

export const onFilter = data => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_STATUS_FILTERED,
			payload: data
		});
	};
};

export const onCancelRelationship = (data, callback) => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_STARTED,
			payload: data.relationId
		});

		cancelRelationship(data).then(
			response => {
				dispatch({
					type: ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_FINISHED,
					payload: response.data.error
				});
				dispatch(getRelationships());
				if (callback) {
					callback();
				}
			},
			error => {
				dispatch({
					type: ADVANCED_MANAGEMENT_CANCEL_RELATIONSHIP_FINISHED,
					payload: error.response.data.errors[0]
				});
				dispatch(getRelationships());
				if (callback) {
					callback();
				}
			}
		);
	};
};

export const cleanErrorCancelRelationship = () => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_CLEAN_ERROR_CANCEL_RELATIONSHIP
		});
	};
};

export const onInviteParticipant = data => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_STARTED
		});

		inviteParticipant(data).then(response => {
			return dispatch({
				type: ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_FINISHED,
				payload: {
					data: response.data,
					isInvitationSuccess: true
				}
			});
		});
	};
};

export const onCloseInviteParticipant = () => {
	return function(dispatch) {
		dispatch(getRelationships());
		dispatch(cleanInviteParticipant());
	};
};

export const cleanInviteParticipant = () => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_INVITE_PARTICIPANT_CLEAN
		});
	};
};

export const onSearchByCPF = (dataCPF, hasRelationships) => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_SEARCH_BY_CPF_STARTED
		});

		searchByCPF(dataCPF).then(response => {
			if (response.data.idUser) {
				return dispatch({
					type: ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED,
					payload: {
						dataParticipantIndication: response.data,
						isInvalidCPF: false,
						isFailureLimitReached: false
					}
				});
			}

			if (response.data.countSuccess === 10) {
				return dispatch({
					type: ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED,
					payload: {
						dataParticipantIndication: response.data,
						isInvitationLimitReached: true
					}
				});
			}

			if (response.data.countFailure === 1) {
				return dispatch({
					type: ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED,
					payload: {
						isInvalidCPF: true,
						renderModalInvalidCPF: false,
						isOneLessAttempt: false,
						dataParticipantIndication: {}
					}
				});
			}

			if (response.data.countFailure === 2) {
				return dispatch({
					type: ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED,
					payload: {
						isInvalidCPF: true,
						renderModalInvalidCPF: true,
						isOneLessAttempt: true,
						dataParticipantIndication: {}
					}
				});
			}

			if (response.data.countFailure >= 3) {
				return dispatch({
					type: ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED,
					payload: {
						isInvalidCPF: false,
						isFailureLimitReached: true,
						renderModalInvalidCPF: false,
						isOneLessAttempt: false,
						dataCurrentStep: hasRelationships ? 1 : 6
					}
				});
			}

			return dispatch({
				type: ADVANCED_MANAGEMENT_SEARCH_BY_CPF_FINISHED,
				payload: {}
			});
		});
	};
};

export const ifRenderModalInvalidCPF = () => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_IF_RENDER_MODAL_INVALID_CPF,
			payload: {
				renderModalInvalidCPF: false
			}
		});
	};
};

export const onSendingFile = value => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_SENDING_FILE,
			payload: {
				sendingFile: value
			}
		});
	};
};

export const setStep = step => {
	window.scrollTo({
		top: 0,
		behavior: "smooth"
	});

	return {
		type: ADVANCED_MANAGEMENT_SET_STEP,
		payload: step
	};
};

export const setDataToStore = data => {
	return {
		type: ADVANCED_MANAGEMENT_STORE_DATA,
		payload: data
	};
};

export const setDataToStoreDocuments = data => {
	return {
		type: ADVANCED_MANAGEMENT_STORE_DATA_DOCUMENTS,
		payload: data
	};
};

export const onSendDocuments = data => {
	return function(dispatch) {
		dispatch({
			type: ADVANCED_MANAGEMENT_SEND_DOCUMENTS_STARTED
		});

		approveRelationship(data).then(
			response => {
				dispatch({
					type: ADVANCED_MANAGEMENT_SEND_DOCUMENTS_FINISHED
				});
			},
			error => {
				dispatch({
					type: ADVANCED_MANAGEMENT_SEND_DOCUMENTS_FINISHED
				});
			}
		);
	};
};
